import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store/store";
import './Toast.scss';
import { closeToast } from "../store/messageSlice";


function Toast() {
    const dispatch = useDispatch();
    const { toastOpened, toastMessage, toastType } = useSelector((state: RootState) => state.message);

    const onCloseClick = () => dispatch(closeToast());

    if (!toastOpened) {
        return <></>
    }

    return <div className={`mafia-toast ${toastType === 'error' ? 'error-toast' : 'info-toast'}`}>
            <div className="mafia-toast-content">{toastMessage}</div>
            <button className="close-button" onClick={onCloseClick}>X</button>
            <div className="mafia-toast-footer">
                <button className="ok-button" onClick={onCloseClick}>OK</button>
            </div>
        </div>

}

export default Toast;